// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 223px;
  /* Место под box-shadow выбранной кнопки (иначе обрезается у нижнего края в scroll/sticky контейнере). */
  padding-bottom: 12px;
}

/* Кнопка категории: картинка слева + название */
.category-nav__btn {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 223px;
  min-height: 47px;
  padding: 3px 12px 3px 12px;
  box-sizing: border-box;
  background: transparent;
  border: none;
  border-radius: 23.5px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #4e3f3a;
  text-align: left;
  transition: background 0.2s, color 0.2s, text-decoration 0.2s;
}

.category-nav__btn:hover {
  background: rgba(255, 255, 255, 0.55);
  color: #df484f;
  text-decoration: none;
  text-shadow: none;
}

.category-nav__btn--selected {
  background: #ffcf8b;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 23.5px;
  color: #4e3f3a;
  text-decoration: none;
  text-shadow: none;
}

.category-nav__btn--selected:hover {
  background: #ffcf8b;
  color: #4e3f3a;
  text-decoration: none;
}

.category-nav__img {
  width: 64px;
  height: 41px;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: #e8e4df;
  background-size: cover;
  background-position: center;
}

.category-nav__img--combo {
  background: linear-gradient(135deg, #2d6a4f 0%, #52b788 100%);
}

.category-nav__name {
  flex: 1;
  min-width: 0;
}

@media (max-width: 1024px) {
  .category-nav {
    min-width: 190px;
  }

  .category-nav__btn {
    width: 190px;
    gap: 12px;
    font-size: 20px;
  }

  .category-nav__img {
    width: 52px;
    height: 36px;
  }
}

@media (max-width: 820px) {
  .category-nav {
    flex-direction: row;
    min-width: 0;
    width: 100%;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 10px;
    -webkit-overflow-scrolling: touch;
  }

  .category-nav__btn {
    width: auto;
    min-width: 156px;
    padding: 5px 10px;
    font-size: 18px;
    line-height: 1.2;
    border: 1px solid rgba(167, 140, 131, 0.6);
  }
}

@media (max-width: 430px) {
  .category-nav__btn {
    min-width: 140px;
    min-height: 42px;
    gap: 8px;
    border-radius: 16px;
    font-size: 16px;
  }

  .category-nav__img {
    width: 42px;
    height: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CategoryNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,wGAAwG;EACxG,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".category-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 223px;\n  /* Место под box-shadow выбранной кнопки (иначе обрезается у нижнего края в scroll/sticky контейнере). */\n  padding-bottom: 12px;\n}\n\n/* Кнопка категории: картинка слева + название */\n.category-nav__btn {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 223px;\n  min-height: 47px;\n  padding: 3px 12px 3px 12px;\n  box-sizing: border-box;\n  background: transparent;\n  border: none;\n  border-radius: 23.5px;\n  cursor: pointer;\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 28px;\n  color: #4e3f3a;\n  text-align: left;\n  transition: background 0.2s, color 0.2s, text-decoration 0.2s;\n}\n\n.category-nav__btn:hover {\n  background: rgba(255, 255, 255, 0.55);\n  color: #df484f;\n  text-decoration: none;\n  text-shadow: none;\n}\n\n.category-nav__btn--selected {\n  background: #ffcf8b;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 23.5px;\n  color: #4e3f3a;\n  text-decoration: none;\n  text-shadow: none;\n}\n\n.category-nav__btn--selected:hover {\n  background: #ffcf8b;\n  color: #4e3f3a;\n  text-decoration: none;\n}\n\n.category-nav__img {\n  width: 64px;\n  height: 41px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background-color: #e8e4df;\n  background-size: cover;\n  background-position: center;\n}\n\n.category-nav__img--combo {\n  background: linear-gradient(135deg, #2d6a4f 0%, #52b788 100%);\n}\n\n.category-nav__name {\n  flex: 1;\n  min-width: 0;\n}\n\n@media (max-width: 1024px) {\n  .category-nav {\n    min-width: 190px;\n  }\n\n  .category-nav__btn {\n    width: 190px;\n    gap: 12px;\n    font-size: 20px;\n  }\n\n  .category-nav__img {\n    width: 52px;\n    height: 36px;\n  }\n}\n\n@media (max-width: 820px) {\n  .category-nav {\n    flex-direction: row;\n    min-width: 0;\n    width: 100%;\n    gap: 8px;\n    overflow-x: auto;\n    padding-bottom: 10px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .category-nav__btn {\n    width: auto;\n    min-width: 156px;\n    padding: 5px 10px;\n    font-size: 18px;\n    line-height: 1.2;\n    border: 1px solid rgba(167, 140, 131, 0.6);\n  }\n}\n\n@media (max-width: 430px) {\n  .category-nav__btn {\n    min-width: 140px;\n    min-height: 42px;\n    gap: 8px;\n    border-radius: 16px;\n    font-size: 16px;\n  }\n\n  .category-nav__img {\n    width: 42px;\n    height: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
